import type { Coordinates } from 'modules/people_chart/lib/Coordinates'
import { Dimensions } from 'modules/people_chart/lib/Dimensions'
import {
  drawHorizontalLine,
  drawLine,
  drawVerticalLine,
  moveCursor,
} from 'modules/people_chart/lib/pathDrawer'

export type PositionalProperties = {
  coordinates: Coordinates
  dimensions: Dimensions
}

type Direction = 'center' | 'left' | 'right'
type Alignment = 'center-top' | 'center-bottom'

export default (source: PositionalProperties, target: PositionalProperties): string => {
  const direction = getDirection(source.coordinates, target.coordinates)

  if (direction === 'center') {
    const alignSource = alignElement('center-bottom', source)
    const alignTarget = alignElement('center-top', target)
    return `${moveCursor('absolute', alignSource)} ${drawLine('absolute', alignTarget)}`
  }

  if (direction == 'left' || direction == 'right') {
    const alignSource = alignElement('center-bottom', source)
    const [alignTargetX, _] = alignElement('center-top', target)
    const cursorPosition = moveCursor('absolute', alignSource)
    const verticalLine = drawVerticalLine('relative', calculateVerticalLine(source, target))
    const horizontalLine = drawHorizontalLine('absolute', alignTargetX)
    return `${cursorPosition} ${verticalLine} ${horizontalLine} ${verticalLine}`
  }

  return ''
}

const calculateVerticalLine = (
  source: PositionalProperties,
  target: PositionalProperties
): number => {
  const sourceY = source.coordinates[1]
  const sourceHeight = source.dimensions[1]
  const targetY = target.coordinates[1]
  const sourceY1 = sourceY + sourceHeight
  const extra = 2
  return (targetY - sourceY1) / 2 + extra
}

const alignElement = (alignment: Alignment, value: PositionalProperties): Coordinates => {
  const [width, height] = value.dimensions
  const [x, y] = value.coordinates

  const xCenter = x + width / 2

  switch (alignment) {
    case 'center-top':
      return [xCenter, y]
    case 'center-bottom':
      return [xCenter, y + height]
  }
}

const getDirection = (source: Coordinates, target: Coordinates): Direction => {
  const sourceX = source[0]
  const targetX = target[0]
  if (sourceX === targetX) return 'center'
  else if (sourceX < targetX) return 'right'
  else return 'left'
}
